import manifest from "../../contracts/startup-status.json";

const STARTUP_STATUS_FAILED: StartupStatus = "failed";

export const STARTUP_WAKE_EVENT = manifest.wakeEvent;

export type StartupStatus = keyof typeof manifest.statuses;
export type StartupPhase = keyof typeof manifest.phases;
export type StartupError = keyof typeof manifest.errors;
export type StartupStatusPayload = {
  status: StartupStatus;
  errorType?: StartupError | null;
  migrationPhase?: StartupPhase | null;
  startedAt?: string | null;
};

export function readStartupStatus(value: unknown): StartupStatusPayload {
  if (!value || typeof value !== "object" || !("status" in value)
    || typeof value.status !== "string" || !Object.hasOwn(manifest.statuses, value.status)) {
    throw new Error("Invalid startup status");
  }
  if ("errorType" in value && value.errorType != null
    && (typeof value.errorType !== "string" || !Object.hasOwn(manifest.errors, value.errorType))) throw new Error("Invalid startup error");
  if (value.status === STARTUP_STATUS_FAILED && (!("errorType" in value) || value.errorType == null)) throw new Error("Missing startup error");
  if ("migrationPhase" in value && value.migrationPhase != null
    && (typeof value.migrationPhase !== "string" || !Object.hasOwn(manifest.phases, value.migrationPhase))) throw new Error("Invalid startup phase");
  if ("startedAt" in value && value.startedAt != null && typeof value.startedAt !== "string") throw new Error("Invalid startup time");
  return value as StartupStatusPayload;
}

/** Entspricht der freigegebenen Backend-Sperre; andere Startfehler bleiben administrative Befunde. */
export function blocksStartup(status: StartupStatusPayload): boolean {
  return status.status === "migrating" || (status.status === "failed" && status.errorType === "database_unavailable");
}
